import React, { useState, useEffect } from 'react';
import Giocatori from '../Giocatori/Giocatori';
import Dificolta from '../Difficolta/Difiicolta';
import MultipleDifficolta from '../MultipleDifficolta/MultipleDifficolta';
import SliderInfinite from '../SliderInfinite/SliderInfinite';
import Singolo_Plancton_1 from '../Single_Player_Easy/Singolo_Plancton_1';
import Singolo_Gamberone_1 from '../Single_Player_Normal/Singolo_Gamberone_1';
import Singolo_Astice_1 from '../Single_Player_Hard/Singolo_Astice_1';
import Coppia_Plancton_1 from '../Multi_Player_Easy/Coppia_Plancton_1';
import Coppia_Gamberone_1 from '../Multi_Player_Normal/Coppia_Gamberone_1';
import Coppia_Astice_1 from '../Multi_Player_Hard/Coppia_Astice_1';
import Avvia_Partita1 from '../Avvia_Partita/Avvia_Partita1';
import Splash1 from '../../assets/Images/Group.png'
import Splash2 from '../../assets/Images/gamberoni_bg_img.png'
import Avvia_Partita2 from '../Avvia_Partita/Avvia_Partita2';
import Avvia_Partita3 from '../Avvia_Partita/Avvia_Partita3';
import Avvia_Partita4 from '../Avvia_Partita/Avvia_Partita4';
import Champion from '../Champion/Champion';
import Loss from '../Loss/Loss';
import Instructions from '../Instruction/Instructions';
const Home = (props) => {
    const [giocatori, setGiocatori] = useState(false);
    const [champion, setChampion] = useState(false)
    const [loss, setLoss] = useState(false)
    const [instruction, setInstruction] = useState(false)
    const [dificolta, setDificolta] = useState(false);
    const [multipleDifficolta, setMultipleDifficolta] = useState(false);
    const [singoloPlanctonEasy, setSingoloPlanctonEasy] = useState(false);
    const [singoloGamberoneNormal, setSingoloGamberoneNormal] = useState(false);
    const [singoloAsticeHard, setSingoloAsticeHard] = useState(false);
    const [showSliderInfinite, setShowSliderInfinite] = useState(false);
    const [multipleCoppiaEasy, setMultipleCoppiaEsay] = useState(false);
    const [multipleoCoppiaNormal, setMultipleCoppiaeNormal] = useState(false);
    const [multipleCoppiaHard, setMultipleCoppiaHard] = useState(false);
    const [avvia, setAvvia] = useState(false)
    const [splash1Visible, setSplash1Visible] = useState(true);
    const [splash2Visible, setSplash2Visible] = useState(false);
    // console.log(champion, 'cham')
    useEffect(() => {
        const timer1 = setTimeout(() => {
            setSplash1Visible(false);
            setSplash2Visible(true);
        }, 3000);
        const timer2 = setTimeout(() => {
            setSplash2Visible(false);
        }, 3000);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
    }, []);
    return (
        <>
            {splash1Visible && (
                <div className="Splash_section animate__slideInLeft bg ">
                    <img className='splash_img1 animate__animated animate__fadeOut' src={Splash1} alt="" />
                </div>
            )}
            {splash2Visible && (
                <div className="giocatori_section">
                    <div className="main_div">
                        <div className="Splash_section animate__slideInLeft bg">
                            {/* <img className='splash_img2 animate__animated ' src={Splash2} alt="" /> */}
                        </div>
                    </div>
                </div>
            )}
            {!splash1Visible && !splash2Visible && (

                <div>
                    {
                        instruction ?
                            <Instructions

                                setInstruction={setInstruction}
                                setGiocatori={setGiocatori}
                                setMultipleDifficolta={setMultipleDifficolta}
                                setDificolta={setDificolta}
                                setShowSliderInfinite={setShowSliderInfinite}
                                setChampion={setChampion}
                                setLoss={setLoss}

                            />

                            :
                            champion ?
                                <Champion
                                    setChampion={setChampion}
                                    setGiocatori={setGiocatori}
                                    setDificolta={setDificolta}
                                    setMultipleDifficolta={setMultipleDifficolta}
                                    setInstruction={setInstruction}

                                />
                                :
                                loss ?
                                    <Loss
                                        setLoss={setLoss}
                                        setGiocatori={setGiocatori}
                                        setDificolta={setDificolta}
                                        setMultipleDifficolta={setMultipleDifficolta}
                                        setInstruction={setInstruction}

                                    />
                                    :
                                    <>
                                        {
                                            !giocatori ? (
                                                <Giocatori setGiocatori={setGiocatori} setInstruction={setInstruction} />
                                            ) : giocatori === 'multiple' ? (
                                                !multipleDifficolta ? (
                                                    <MultipleDifficolta
                                                        setGiocatori={setGiocatori}
                                                        setMultipleDifficolta={setMultipleDifficolta}
                                                        setShowSliderInfinite={setShowSliderInfinite}
                                                        setMultipleCoppiaEsay={setMultipleCoppiaEsay}
                                                        setMultipleCoppiaeNormal={setMultipleCoppiaeNormal}
                                                        setMultipleCoppiaHard={setMultipleCoppiaHard}
                                                        setInstruction={setInstruction}


                                                    />
                                                ) : (
                                                    <div>
                                                        {showSliderInfinite ? (
                                                            <SliderInfinite
                                                                setShowSliderInfinite={setShowSliderInfinite}
                                                                setMultipleDifficolta={setMultipleDifficolta}
                                                                setDificolta={setDificolta}

                                                            />
                                                        ) : !avvia ? (
                                                            <Avvia_Partita1 setAvvia={setAvvia} />
                                                        ) : (
                                                            <div>
                                                                {localStorage.getItem('clickedItem') === 'CoppiaPlancton' && multipleCoppiaEasy ? (


                                                                    <Coppia_Plancton_1
                                                                        setGiocatori={setGiocatori}
                                                                        setMultipleDifficolta={setMultipleDifficolta}
                                                                        setDificolta={setDificolta}
                                                                        setShowSliderInfinite={setShowSliderInfinite}
                                                                        setAvvia={setAvvia}
                                                                        setChampion={setChampion}
                                                                        setLoss={setLoss}


                                                                    />
                                                                ) : localStorage.getItem('clickedItem') === 'CoppiaGamberone' && multipleoCoppiaNormal ? (
                                                                    <Coppia_Gamberone_1
                                                                        setGiocatori={setGiocatori}
                                                                        setMultipleDifficolta={setMultipleDifficolta}
                                                                        setDificolta={setDificolta}
                                                                        setShowSliderInfinite={setShowSliderInfinite}
                                                                        setAvvia={setAvvia}
                                                                        setChampion={setChampion}

                                                                        setLoss={setLoss}



                                                                    />
                                                                ) : localStorage.getItem('clickedItem') === 'CoppiaAstice' && multipleCoppiaHard ? (
                                                                    <Coppia_Astice_1
                                                                        setGiocatori={setGiocatori}
                                                                        setMultipleDifficolta={setMultipleDifficolta}
                                                                        setDificolta={setDificolta}
                                                                        setShowSliderInfinite={setShowSliderInfinite}
                                                                        setAvvia={setAvvia}
                                                                        setChampion={setChampion}
                                                                        setLoss={setLoss}

                                                                    />
                                                                ) : null}
                                                            </div>
                                                        )}
                                                    </div>

                                                )
                                            ) : !dificolta ? (
                                                <Dificolta
                                                    {...props}
                                                    setGiocatori={setGiocatori}
                                                    setDificolta={setDificolta}
                                                    setSingoloPlanctonEasy={setSingoloPlanctonEasy}
                                                    setSingoloGamberoneNormal={setSingoloGamberoneNormal}
                                                    setSingoloAsticeHard={setSingoloAsticeHard}
                                                    setShowSliderInfinite={setShowSliderInfinite}
                                                    setInstruction={setInstruction}

                                                />
                                            ) : (
                                                <div>

                                                    {showSliderInfinite ? (
                                                        <SliderInfinite
                                                            setShowSliderInfinite={setShowSliderInfinite}
                                                            setDificolta={setDificolta}
                                                            setMultipleDifficolta={setMultipleDifficolta}
                                                            setInstruction={setInstruction}

                                                        />
                                                    ) : !avvia ? (
                                                        <Avvia_Partita1 setAvvia={setAvvia} />
                                                    ) :
                                                        (
                                                            <div>
                                                                {localStorage.getItem('clickedItem') === 'SingoloPlancton' && singoloPlanctonEasy ? (
                                                                    <Singolo_Plancton_1
                                                                        setGiocatori={setGiocatori}
                                                                        setDificolta={setDificolta}
                                                                        setMultipleDifficolta={setMultipleDifficolta}
                                                                        setShowSliderInfinite={setShowSliderInfinite}
                                                                        setAvvia={setAvvia}
                                                                        setChampion={setChampion}
                                                                        setLoss={setLoss}


                                                                    />
                                                                ) :
                                                                    localStorage.getItem('clickedItem') === 'SingoloGamberone' && singoloGamberoneNormal ? (
                                                                        <Singolo_Gamberone_1
                                                                            setGiocatori={setGiocatori}
                                                                            setDificolta={setDificolta}
                                                                            setMultipleDifficolta={setMultipleDifficolta}
                                                                            setShowSliderInfinite={setShowSliderInfinite}
                                                                            setAvvia={setAvvia}
                                                                            setChampion={setChampion}
                                                                            setLoss={setLoss}


                                                                        />
                                                                    ) : localStorage.getItem('clickedItem') === 'SingoloAstice' && singoloAsticeHard ? (
                                                                        <Singolo_Astice_1
                                                                            setGiocatori={setGiocatori}
                                                                            setDificolta={setDificolta}
                                                                            setMultipleDifficolta={setMultipleDifficolta}
                                                                            setShowSliderInfinite={setShowSliderInfinite}
                                                                            setAvvia={setAvvia}
                                                                            setChampion={setChampion}
                                                                            setLoss={setLoss}

                                                                        />
                                                                    ) : null
                                                                }

                                                            </div>
                                                        )}

                                                </div>

                                            )}
                                    </>
                    }
                </div >
            )}

        </>


    );
};

export default Home;
